import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { ICustomerForecastRepository } from '@/coreInfrastructureModule/interfaces/ICustomerForecastRepository';
import { GetCustomerForecastRateSortTypeEnum } from '@/coreInfrastructureModule/axios/generated/customerForecastManage';
import { IForecastAccuracyRateResult } from '../domains/entities/forecastAccuracyRateResult';
import { GetForecastAccuracyRateAdapter } from '../adapter/getForecastAccuracyRateAdapter';

/**
 * 内示正答率を取得するUseCase
 */
export class GetForecastAccuracyRateUseCase {
  private repository: ICustomerForecastRepository;

  /**
   * コンストラクタ
   * @param repository - 内示リポジトリ
   */
  constructor(repository: ICustomerForecastRepository) {
    this.repository = repository;
  }

  /**
   * 内示正答率を取得する
   * @param receiveYear - 表示年
   * @param receiveMonth - 表示月
   * @param displayMonths - 表示月数
   * @param limit - 情報の表示最大数
   * @param offset - 表示する情報のオフセット
   * @param forecastForReceiptResponsibleUserId - 受領用内示担当者ID（オプション）
   * @param sortKey - ソート対象のカラム（オプション）
   * @param isAsc - 昇順かどうか（オプション）
   * @param sortTargetYear - ソート対象の年（オプション）
   * @param sortTargetMonth - ソート対象の月（オプション）
   */
  public Execute = async (
    receiveYear: number,
    receiveMonth: number,
    displayMonths: number,
    limit: number,
    offset: number,
    forecastForReceiptResponsibleUserId?: string,
    sortKey?: string,
    isAsc?: boolean,
    sortTargetYear?: number,
    sortTargetMonth?: number
  ): Promise<INetworkResult<IForecastAccuracyRateResult, Error>> => {
    try {
      // ソートタイプを決定
      const sortType: GetCustomerForecastRateSortTypeEnum = isAsc === false ? 'DESC' : 'ASC';

      const result = await this.repository.getForecastRate(
        sortType,
        receiveYear,
        receiveMonth,
        displayMonths,
        limit,
        offset,
        forecastForReceiptResponsibleUserId,
        sortKey,
        sortTargetYear,
        sortTargetMonth
      );

      switch (result.status.type) {
        case 'success':
          break;
        case 'error':
          throw result.status.error;
        default:
          throw new Error('Invalid status');
      }

      const data = GetForecastAccuracyRateAdapter.adaptForResponse(result.status.data);

      return {
        status: {
          type: 'success',
          data: data,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('内示正答率の取得に失敗しました'),
        },
      };
    }
  };
}
